import { Component, Output, EventEmitter } from "@angular/core"
import { ModalComponent } from "../modal.component"

@Component({
  selector: 'new-video-customer-modal',
  styles: [`
    .fa-play-circle {
      font-size: 56px;
    }
  `],
  template: `
  <modal (outsideClick)="close.emit()">
    <div class="far fa-play-circle text-success mb-3"></div>
    <h3>
      Welcome to Verblio Vids!
    </h3>
    <hr class="brand-hr"/>
    <p class="h4-subheader">Getting your first video is easy as 1, 2, 3.</p>
    <ul class="list-unstyled">
      <li><strong>Step 1:</strong> start a new request</li>
      <li><strong>Step 2:</strong> select your content</li>
      <li><strong>Step 3:</strong> tell our team about your preferences</li>
    </ul>
    <button class="mt-2 btn btn-secondary" (click)="newRequest.emit()">Start a new request</button>
  </modal>
  `
})
export class NewVideoCustomerModal extends ModalComponent {
  @Output() newRequest: EventEmitter<null> = new EventEmitter<null>()
}
